<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2 elevation-5"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <ValidationObserver ref="CancerRegisterDetailForm" v-slot="{ valid, pristine, reset }" class="layout-column flex">
        <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
          <div class="layout-row">
            <lx-btn small
                    hide-label
                    classes="mr-1"
                    :disabled="isPristine"
                    @click="clearForm(reset)"
                    icon="mdi-undo-variant"
                    :tooltip="$t('COMPONENT_REGISTER.UNDO_CHANGES')"
                    :label="$t('buttons.revert.value')"></lx-btn>
            <lx-btn small
                    hide-label
                    classes="mr-1"
                    :disabled="!valid || isPristine"
                    @click="saveRegisterData"
                    icon="save"
                    :tooltip="$t('COMPONENT_REGISTER.SAVE_CHANGES')"
                    :label="$t('buttons.save.value')"></lx-btn>
          </div>
          <div class="flex layout-row"></div>
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <div class="flex layout-column pa-2" style="overflow-y: auto;">
          <v-progress-linear :indeterminate="loading"
                             v-if="loading"
                             color="red accent-2"
                             background-color="red lighten-4"
                             class="ma-0"
                             style="border-radius:0;height:4px;position: absolute;top:56px;left:0; width:100%;"></v-progress-linear>

          <lx-expansion-panels :single-open="false" v-model="panel">
            <lx-expansion-panel disabled>
              <lx-expansion-panel-header icon="mdi-account-circle"
                                         disabled
                                         :main-headline="$t('COMPONENT_REGISTER.HEADER')"
                                         :sub-headline="$t('COMPONENT_REGISTER.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>

              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <div class="layout-row layout-wrap flex-100">

                    <!-- Name (Krebsregister) -->

                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" ref="name" name="name"
                                           rules="required|min:2"
                                           v-slot="{ errors }">
                        <v-text-field
                          :dark="compColor.isInDarkMode"
                          v-model="model.name"
                          :label="$t('COMPONENT_REGISTER.NAME') + ' *'"
                          :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                          :error-messages="errors[0]"
                          :dense="denseFields"
                          outlined
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- InstallationsId -->

                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" ref="installation_id" name="installation_id"
                                           rules=""
                                           v-slot="{ errors }">
                        <v-text-field
                          :dark="compColor.isInDarkMode"
                          v-model="model.installation_id"
                          :label="$t('COMPONENT_REGISTER.INST_ID')"
                          :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                          :error-messages="errors[0]"
                          :dense="denseFields"
                          outlined
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- Button Zusatzitem hinzufügen -->

                    <div class="flex-gt-sm-100 flex-100">
                      <div class="layout-column">
                        <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
                          <lx-btn icon="add_circle"
                                  :color="compColor.primeColor"
                                  :iconColor="'white'"
                                  :tooltip="$t('COMPONENT_REGISTER.ADDITION_ITEM.ADD_NEW_ITEM')"
                                  :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.ADD_NEW_ITEM')"
                                  iconSize="21"
                                  :width="'auto'"
                                  :height="35"
                                  classes="text-none"
                                  @click="addNewItem('additionalItem')"
                          ></lx-btn>
                        </div>

                        <v-divider class="mx-2" v-bind:style="{'border-color':compColor.lightDivider}" v-if="model.additional_items && model.additional_items.length > 0"></v-divider>

                        <div :key="index" v-for="(item, index) in model.additional_items"
                             class="layout-column pa-0 ma-2 pb-2"
                             :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
                             style="border-radius:4px;"
                             :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

                          <div class="layout-row layout-wrap flex px-4 pt-4">

                            <!-- Name (Merkmal) -->

                            <div class="flex-gt-sm-33 flex-100 px-2">
                              <validation-provider tag="div"
                                                   :name="'additional_items.' + index + '.name'"
                                                   :ref="'additional_items.' + index + '.name'"
                                                   rules="required"
                                                   v-slot="{ errors }">
                                <v-text-field
                                  :dark="compColor.isInDarkMode"
                                  v-model="item.name"
                                  :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.NAME') + ' *'"
                                  :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                                  :error-messages="errors[0]"
                                  :hide-details="!errors || errors.length <= 0"
                                  :dense="denseFields"
                                  outlined
                                ></v-text-field>
                              </validation-provider>
                            </div>

                            <!-- Zu melden wenn -->

                            <div class="flex-gt-sm-33 flex-100 px-2">
                              <validation-provider tag="div"
                                                   :name="'additional_items.' + index + '.form_types'"
                                                   :ref="'additional_items.' + index + '.form_types'"
                                                   rules="required"
                                                   v-slot="{ errors }">
                                <v-select
                                  :color="compColor.primeColor"
                                  :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.FORM_TYPES') + ' *'"
                                  v-model="item.form_types"
                                  :items="formTypeList"
                                  :hide-details="!errors || errors.length <= 0"
                                  outlined
                                  multiple
                                  :dense="denseFields"
                                  :error-messages="errors[0]"
                                  :menu-props="{ bottom: true, offsetY: true }"
                                  :dark="compColor.isInDarkMode">
                                  <template v-slot:item="{item, on, attrs}">
                                    <v-list-item v-on="on" style="height: 40px;">
                                      <v-list-item-action style="margin-right: 10px">
                                        <v-simple-checkbox
                                          :value="attrs.inputValue"
                                          v-on="on"
                                          :dark="compColor.isInDarkMode"
                                          :color="compColor.primeColor"
                                          :ripple="false"
                                        ></v-simple-checkbox>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                        <v-list-item-title>
                                          <label :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                                 class="lighten-4 text--darken-2"
                                                 :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}"
                                          >{{ item.text }}</label>
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </template>
                                </v-select>
                              </validation-provider>
                            </div>

                            <!-- Eingabetyp -->

                            <div class="flex-gt-sm-25 flex-100 px-2 mr-2">
                              <validation-provider tag="div"
                                                   :name="'additional_items.' + index + '.content.element_type'"
                                                   :ref="'additional_items.' + index + '.content.element_type'"
                                                   rules="required"
                                                   v-slot="{ errors }">
                                <v-select
                                  :color="compColor.primeColor"
                                  :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.ELEMENT_TYPE') + ' *'"
                                  v-model="item.content.element_type"
                                  :items="elementTypeList"
                                  :hide-details="!errors || errors.length <= 0"
                                  outlined
                                  :dense="denseFields"
                                  :error-messages="errors[0]"
                                  :menu-props="{ bottom: true, offsetY: true }"
                                  :dark="compColor.isInDarkMode">
                                  <template v-slot:item="{ item, on, attrs }">
                                    <v-list-item v-on="on"
                                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                                      <v-list-item-content class="py-0">
                                        <label style="cursor:pointer;"
                                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </template>
                                </v-select>
                              </validation-provider>
                            </div>

                            <!-- active switch -->

                            <div class="flex pr-2 mt-n1">
                              <validation-provider tag="div"
                                                   :name="'additional_items.' + index + '.active'"
                                                   :ref="'additional_items.' + index + '.active'"
                                                   rules="">
                                <v-switch
                                  v-model="item.active"
                                  class="ml-2 my-0"
                                  dense
                                  inset
                                  :color="compColor.prime"
                                  :dark="isDarkMode"
                                  hide-details
                                >
                                  <template #label>
                                    <span class="body-2 blue-grey--text text--lighten-2 ml-n2">{{ $t('COMPONENT_REGISTER.ADDITION_ITEM.IS_ACTIVE') }}</span>
                                  </template>
                                </v-switch>
                              </validation-provider>
                            </div>
                          </div>

                          <div class="pl-4" v-if="item.content && item.content.element_type && item.content.element_type==='select'">

                            <!-- Auswahlelemente -->

                            <div class="flex-gt-sm-100 flex-100">
                              <div class="layout-column">
                                <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
                                  <lx-btn icon="add_circle"
                                          :color="compColor.primeColor"
                                          :iconColor="'white'"
                                          :tooltip="$t('COMPONENT_REGISTER.ADDITION_ITEM.SELECT_VALUE.ADD_NEW')"
                                          :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.SELECT_VALUE.ADD_NEW')"
                                          iconSize="21"
                                          :width="'auto'"
                                          :height="35"
                                          classes="text-none"
                                          @click="addNewItem('selectValue', index)"
                                  ></lx-btn>
                                </div>

                                <v-divider class="mx-2 mb-2" v-bind:style="{'border-color':compColor.lightDivider}" v-if="item.content.select_values && item.content.select_values.length > 0"></v-divider>

                                <div :key="valueIndex" v-for="(valueItem, valueIndex) in item.content.select_values"
                                     class="layout-row pa-0 mx-2 my-1"
                                     :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-2': !compColor.isInDarkMode}"
                                     style="border-radius:4px;"
                                     :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

                                  <div class="layout-row layout-wrap flex px-4 pt-3">

                                    <!-- Text -->

                                    <div class="flex-gt-sm-33 flex-100 px-2">
                                      <validation-provider tag="div"
                                                           :name="'additional_items.' + index + '.content.select_values.'+valueIndex+'.text'"
                                                           :ref="'additional_items.' + index + '.content.select_values.'+valueIndex+'.text'"
                                                           rules="required"
                                                           v-slot="{ errors }">
                                        <v-text-field
                                          :dark="compColor.isInDarkMode"
                                          v-model="valueItem.text"
                                          class="mb-2"
                                          :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.SELECT_VALUE.TEXT') + ' *'"
                                          :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                                          :error-messages="errors[0]"
                                          :hide-details="!errors || errors.length <= 0"
                                          :dense="denseFields"
                                          outlined
                                        ></v-text-field>
                                      </validation-provider>
                                    </div>

                                    <!-- Value -->

                                    <div class="flex-gt-sm-33 flex-100 px-2">
                                      <validation-provider tag="div"
                                                           :name="'additional_items.' + index + '.content.select_values.'+valueIndex+'.value'"
                                                           :ref="'additional_items.' + index + '.content.select_values.'+valueIndex+'.value'"
                                                           rules="required"
                                                           v-slot="{ errors }">
                                        <v-text-field
                                          :dark="compColor.isInDarkMode"
                                          v-model="valueItem.value"
                                          class="mb-2"
                                          :label="$t('COMPONENT_REGISTER.ADDITION_ITEM.SELECT_VALUE.VALUE') + ' *'"
                                          :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                                          :error-messages="errors[0]"
                                          :hide-details="!errors || errors.length <= 0"
                                          :dense="denseFields"
                                          outlined
                                        ></v-text-field>
                                      </validation-provider>
                                    </div>
                                  </div>

                                  <div class="layout-column layout-align-center-center px-3"
                                       :class="{'grey lighten-2': !compColor.isInDarkMode}"
                                       :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

                                    <lx-btn @click="deleteItem(index, valueIndex)"
                                            :color="compColor.primeColor"
                                            :iconColor="'white'"
                                            iconSize="21"
                                            :width="30"
                                            :height="30"
                                            icon="delete_forever"></lx-btn>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>
          </lx-expansion-panels>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'CancerRegisterDetails',
  props: ['registerId', 'tabid'],
  data () {
    return {
      loading: false,
      panel: [0],
      model: {
        additional_items: []
      },
      oldModel: null,
      formTypeList: [
        { text: this.$t('forms.register'), value: 'register' },
        { text: this.$t('forms.progress'), value: 'progress' },
        { text: this.$t('forms.operation'), value: 'operation' },
        { text: this.$t('forms.systemicTherapy'), value: 'systemicTherapy' },
        { text: this.$t('forms.radiationTherapy'), value: 'radiationTherapy' },
        { text: this.$t('forms.tumorConference'), value: 'tumorConference' },
        { text: this.$t('forms.death'), value: 'death' }
      ],
      elementTypeList: [
        { text: this.$t('COMPONENT_REGISTER.ADDITION_ITEM.ELEMENT_TYPES.SELECT'), value: 'select' },
        { text: this.$t('COMPONENT_REGISTER.ADDITION_ITEM.ELEMENT_TYPES.INPUT'), value: 'input' }
      ]
    }
  },
  created () {
    if (this.registerId) {
      this.getRegisterData()
    } else {
      this.oldModel = lodash.cloneDeep(this.model, true)
    }
  },
  methods: {
    /**
     * wird aufgerufen, wenn man den zurücksetzen Button drückt.
     * - Ursprungsmodel wird wieder an model übergeben
     * - alle Fehler werden gelöscht
     * - alle Felder werden zurückgesetzt, sind also pristine und NICHT dirty
     * */
    clearForm (reset) {
      reset()
      this.model = lodash.cloneDeep(this.oldModel)
    },

    /**
     * wird aufgerufen, wenn man den speichern Button drückt.
     *
     * 1 Fall neu anlegen (RegisterID NICHT vorhanden === Neuanlage):
     *    - per axios.post('/register'...') Model schicken
     *    - im Erfolgsfall route zu RegisterDetails erneut aufrufen, diesmal mit erhaltener RegisterID
     * 2 Fall Register updaten (RegisterID vorhanden === Update):
     *    - per axios.put('/register'...') mit RegisterID und Model wird register upgedatet
     *    - anschließend GetData ausgeführt
     *
     * */
    saveRegisterData () {
      if (this.loading) return
      this.loading = true

      if (this.registerId) {
        this.$http.put('/register/' + this.registerId, this.model)
          .then((res) => {
            this.loading = false
            this.getRegisterData()

            if (this.$refs.CancerRegisterDetailForm) {
              this.$refs.CancerRegisterDetailForm.reset()
            }
            this.NotifySuccess(res, this.$t('COMPONENT_REGISTER.REGISTER_SUCCESSFULLY_SAVED'))
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$http.post('/register', this.model)
          .then(res => {
            this.loading = false

            if (res.data && res.data.id) {
              // add new tab with saved register and redirect to tab
              this.addTabToStore({
                routeName: 'CancerRegisterDetails',
                routeParams: { registerId: res.data.id },
                options: {
                  headline: this.$t('COMPONENT_REGISTER.REGISTER_SHORT_NAME') + ' ' + res.data.name
                }
              })

              // clear form of new register
              this.clearForm(this.$refs.CancerRegisterDetailForm.reset)
            }
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.loading = false
          })
      }
    },

    /**
     * Get selected register from db
     */
    getRegisterData () {
      if (this.loading) return
      this.loading = true

      this.$http.get('/register/' + this.registerId)
        .then(res => {
          if (res.data) {
            this.model = res.data
            this.oldModel = lodash.cloneDeep(this.model)
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * Add new element to an array
     */
    addNewItem (type, index) {
      if (type === 'additionalItem') {
        if (!this.model.additional_items) {
          this.$set(this.model, 'additional_items', [])
        }

        this.$set(this.model.additional_items, this.model.additional_items.length, { content: {}, active: true })
      } else if (type === 'selectValue') {
        if (!this.model.additional_items[index].content.select_values) {
          this.$set(this.model.additional_items[index].content, 'select_values', [])
        }

        this.$set(this.model.additional_items[index].content.select_values, this.model.additional_items[index].content.select_values.length, {})
      }
    },

    deleteItem (index, valueIndex) {
      this.$delete(this.model.additional_items[index].content.select_values, valueIndex)
    }
  },
  watch: {
    isPristine (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.$nextTick(() => {
          this.updateTab({ id: this.tabid, show: true })
        })
      }
      if (newValue && !oldValue) {
        this.$nextTick(() => {
          this.updateTab({ id: this.tabid, show: false })
        })
      }
    }
  },
  computed: {
    isPristine () {
      if (!this.oldModel) {
        return false
      }
      return JSON.stringify(this.oldModel) === JSON.stringify(this.model)
    }
  }
}
</script>
